import * as calendarLink from "calendar-link";
import createTextVersion from "textversionjs";

window.remindMe = function(caller, provider) {
  try {
    const target = caller.parentNode.parentNode.parentNode.parentNode.getElementsByClassName(
      "stream-data"
    )[0];

    const options = {
      date: target.getElementsByClassName("date")[0].getAttribute("data-date"),
      stream: target.getAttribute("data-stream"),
      channel: target.getAttribute("data-channel"),
      url: target.getAttribute("data-url"),
      description: createTextVersion(
        target
          .getElementsByClassName("description")[0]
          .getAttribute("data-description")
      ),
    };

    if (target.getElementsByClassName("date")[0].getAttribute("data-guest")) {
      const tz =
        Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/London";

      const dGMT = new Date(options.date);
      const dUTC = new Date(
        Date.UTC(
          dGMT.getFullYear(),
          dGMT.getMonth(),
          dGMT.getDate(),
          dGMT.getHours(),
          dGMT.getMinutes(),
          dGMT.getSeconds(),
          dGMT.getMilliseconds()
        )
      );

      const time = new Date(
        dUTC.toLocaleString("en-US", {
          timeZone: tz,
        })
      );

      options.date = time.toString();
    }

    const event = {
      start: new Date(options.date).toString(),
      duration: [1, "hour"],
      title: `[${options.channel}] ${options.stream}`,
      description: options.description,
      location: "AymoLive.com",
      url: options.url,
    };

    if (calendarLink[provider]) {
      let link = calendarLink[provider](event);
      if (provider === "ics") {
        window.open(link);
      } else {
        window.open(link, "_blank");
      }
    }
  } catch (e) {
    console.error(`Error generating calendar event link: ${JSON.stringify(e)}`);
  }
};
